// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const espnApi = createApi({
  reducerPath: 'espnApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://nffservice-47oh6fhqtq-uc.a.run.app/' }),
  endpoints: (builder) => ({
    getLeagueByName: builder.query({
      query: (args) => {
        const { leagueId, year, week } = args;
        return {
          url: `leagues/${leagueId}`,
          params: { year, week },
        };
      }
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLeagueByNameQuery } = espnApi;
